<template>
  <div class="controled">
    <div class="guide1">
      <div class="guide-text">1. 获取服务</div>
      <div class="guide-text">
        前往Synology套件中心安装<span class="green">File Station</span>
      </div>
      <div class="twm-icon">
        <img :src="icon56" alt="" />
      </div>
      <div class="guide-text">2. 开启服务</div>
      <div class="guide-text">
        前往 控制面板->登录门户->应用程序->开启http服务为默认端口即可
      </div>
      <div class="twm-icon">
        <img :src="icon57" alt="" />
      </div>
      <div class="guide-text">3. 访问服务</div>
      <div class="guide-text">
        通过节点小宝客户端，点击“远程照片”即可一键直达
      </div>
      <div class="twm-icon">
        <img :src="icon58" alt="" />
      </div>
      <div class="twm-icon">
        <img :src="icon59" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InstallControled",
  props: ["currentid"],
  data: function () {
    return {
      icon56: require("../../assets/help/icon56.png"),
      icon57: require("../../assets/help/icon57.png"),
      icon58: require("../../assets/help/icon58.png"),
      icon59: require("../../assets/help/icon59.png"),
    };
  },
  methods: {
    vipGuideClick: function () {
      this.$emit("vipGuideClick");
    },
    goClick: function (data) {
      let routeUrl = this.$router.resolve({
        path: data, // 这里的路径就可以正常的写，不需要添加_blank: true
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style scoped lang="less">
.controled {
  .guide1 {
    .guide-title {
      margin-bottom: 30px;
      margin-top: 30px;
      font-weight: 500;
      color: #222429;
      font-size: 24px;
    }
    .content {
      font-size: 16px;
      div {
        line-height: 30px;
      }
    }
    .line {
      margin: 20px 0;
      width: 100%;
      height: 1px;
      background-color: #ccced4;
    }
    .guide-text {
      font-size: 16px;
      color: #24292f;
      line-height: 28px;
      span {
        color: #3370ff;
        cursor: pointer;
      }
      a {
        text-decoration: none;
        color: #3370ff;
      }
      .green {
        color: #2ea121;
        font-weight: 900;
      }
      .go-text {
        text-decoration: underline;
        color: #24292f;
        cursor: pointer;
      }
    }
    .twm-icon {
      margin-top: 15px;
      margin-bottom: 15px;
      img {
        max-width: 100%;
      }
    }
    .twm-icon2 {
      width: 50%;
    }
    .twm-icon3 {
      margin: 0 auto;
    }
    .mt {
      margin-top: 40px;
    }
    .ml {
      margin-left: 20px;
    }
    .warm-wrap {
      padding: 16px;
      padding-left: 3px;
      width: 100%;
      border: 1px solid #bacefd;
      background-color: #f0f4ff;
      box-sizing: border-box;
      border-radius: 8px;
      .warms {
        padding-left: 40px;
      }
    }
  }
}
</style>